import React from 'react';
import { useAuth } from '../context/AuthContext';
import RiskAnalysis from '../components/RiskAnalysis';

// Standalone read-only Risk Analysis screen for department roles who view/sign off
// on RA but have no Order Execution access. Reuses the RA component with gpos=[]:
// it lists the company's RAs (company-scoped via /risk), opens each read-only
// (canFill is false for these roles), with no "start new" affordance and no OE state.
// Cost figures are stripped server-side from the snapshot for non-costing roles.
export default function RiskAnalysisPage() {
  const { user } = useAuth();
  return (
    <div style={{ minHeight: '100vh', background: 'transparent', fontFamily: 'inherit' }}>
      <div style={{ padding: 24 }}>
        <h2 style={{ margin: '0 0 14px', fontSize: 20, color: '#1a1a2e' }}>🛡️ Risk Analysis</h2>
        <RiskAnalysis user={user} gpos={[]} />
      </div>
    </div>
  );
}
